module.exports = __webpack_public_path__ + "static/img/haimalogo.667e7343.png";